{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://protocol.clawlet.invalid/v1/params/2026.10.4.json",
  "title": "Exposed parameters of image version 2026.10.4",
  "description": "The only fields a revision may carry in params for this image version: the assistants of one gateway. Each assistant is an agent with its own persona, its own Telegram bot and its own binding. The keys of assistants are the ids of the assistants, which never change. A secret of x-assistant-secrets exists once per assistant, named <NAME>__<ID> (the id in uppercase, '-' as '_'). An unknown field rejects the revision.",
  "type": "object",
  "additionalProperties": false,
  "required": ["assistants"],
  "x-assistant-secrets": [
    {
      "name": "TELEGRAM_BOT_TOKEN",
      "title": "Telegram bot token",
      "description": "The token BotFather gave for the bot of this assistant. Sealed to the key of the server: the plane cannot read it back."
    }
  ],
  "properties": {
    "assistants": {
      "type": "object",
      "title": "Assistants",
      "description": "The assistants of the workspace, by id: lowercase letters, digits and '-'.",
      "minProperties": 1,
      "maxProperties": 5,
      "propertyNames": {
        "pattern": "^[a-z0-9]([a-z0-9-]{0,30}[a-z0-9])?$"
      },
      "additionalProperties": {
        "type": "object",
        "title": "Assistant",
        "additionalProperties": false,
        "required": ["agentName", "model"],
        "properties": {
          "agentName": {
            "type": "string",
            "title": "Agent name",
            "description": "The name the agent introduces itself with.",
            "minLength": 1,
            "maxLength": 40
          },
          "avatar": {
            "type": "string",
            "title": "Avatar",
            "x-widget": "image",
            "description": "The picture of the agent, shown where the agent shows its identity. A PNG, JPEG or WebP image as a base64 data URI, at most 128 KiB of text.",
            "maxLength": 131072,
            "pattern": "^data:image/(png|jpeg|webp);base64,[A-Za-z0-9+/]+={0,2}$"
          },
          "model": {
            "type": "string",
            "title": "Model",
            "x-audience": "operator",
            "description": "Flash is quick and cheap; Pro thinks longer and costs more.",
            "enum": ["deepseek/deepseek-v4-flash", "deepseek/deepseek-v4-pro"]
          },
          "thinking": {
            "type": "string",
            "title": "Thinking",
            "x-audience": "operator",
            "description": "How much the model reasons before answering.",
            "enum": ["off", "low", "high"]
          },
          "telegram": {
            "type": "object",
            "title": "Telegram",
            "additionalProperties": false,
            "properties": {
              "allowFrom": {
                "type": "array",
                "title": "Allowed users",
                "description": "Telegram user ids allowed to talk to the agent, one per line.",
                "items": {
                  "type": "string",
                  "description": "A numeric Telegram user id.",
                  "pattern": "^[0-9]{5,15}$"
                }
              },
              "groups": {
                "type": "boolean",
                "title": "Answer in groups",
                "description": "Whether the agent answers in group chats when mentioned."
              },
              "acceptRequests": {
                "type": "boolean",
                "title": "Accept requests",
                "description": "Whoever writes to the bot and is not allowed yet gets a code and waits: an owner allows them from the plane. Off: only the allowed users get an answer."
              },
              "public": {
                "type": "boolean",
                "title": "Open to everyone",
                "x-audience": "operator",
                "description": "Anyone who finds the bot can talk to it, at the operator's cost: for a front desk, not for a personal assistant. Commands stay to the allowed users."
              }
            }
          }
        }
      }
    }
  }
}
